module.exports = __webpack_public_path__ + "static/media/roboto-greek-400-normal.c1e9793c.woff2";